var __awaiter =
  (this && this.__awaiter) ||
  function(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : new P(function(resolve) {
              resolve(result.value);
            }).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
var __generator =
  (this && this.__generator) ||
  function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: [],
      },
      f,
      y,
      t,
      g;
    return (
      (g = { next: verb(0), throw: verb(1), return: verb(2) }),
      typeof Symbol === "function" &&
        (g[Symbol.iterator] = function() {
          return this;
        }),
      g
    );
    function verb(n) {
      return function(v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_)
        try {
          if (
            ((f = 1),
            y &&
              (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) &&
              !(t = t.call(y, op[1])).done)
          )
            return t;
          if (((y = 0), t)) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return { value: op[1], done: false };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (!((t = _.trys), (t = t.length > 0 && t[t.length - 1])) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2]) _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      if (op[0] & 5) throw op[1];
      return { value: op[0] ? op[1] : void 0, done: true };
    }
  };
var _this = this;
export var processResponse = function(response) {
  return __awaiter(_this, void 0, void 0, function() {
    var _a, e_1, _b;
    return __generator(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (response.status === 204) {
            return [2 /*return*/, { data: undefined, responseError: false }];
          }
          if (!(response.headers.get("content-type") || "").includes("application/json")) return [3 /*break*/, 5];
          _c.label = 1;
        case 1:
          _c.trys.push([1, 3, , 4]);
          _a = {};
          return [4 /*yield*/, response.json()];
        case 2:
          return [2 /*return*/, ((_a.data = _c.sent()), (_a.responseError = false), _a)];
        case 3:
          e_1 = _c.sent();
          return [
            2 /*return*/,
            {
              data: e_1.message,
              responseError: true,
            },
          ];
        case 4:
          return [3 /*break*/, 7];
        case 5:
          _b = {};
          return [4 /*yield*/, response.text()];
        case 6:
          return [2 /*return*/, ((_b.data = _c.sent()), (_b.responseError = false), _b)];
        case 7:
          return [2 /*return*/];
      }
    });
  });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvY2Vzc1Jlc3BvbnNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWwvcHJvY2Vzc1Jlc3BvbnNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsaUJBdUJBO0FBdkJBLE1BQU0sQ0FBQyxJQUFNLGVBQWUsR0FBRyxVQUFPLFFBQWtCOzs7OztnQkFDdEQsSUFBSSxRQUFRLENBQUMsTUFBTSxLQUFLLEdBQUcsRUFBRTtvQkFDM0Isc0JBQU8sRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLGFBQWEsRUFBRSxLQUFLLEVBQUUsRUFBQztpQkFDbEQ7cUJBQ0csQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxjQUFjLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQyxRQUFRLENBQUMsa0JBQWtCLENBQUMsRUFBekUsd0JBQXlFOzs7OztnQkFHakUscUJBQU0sUUFBUSxDQUFDLElBQUksRUFBRSxFQUFBO29CQUQ3Qix1QkFDRSxPQUFJLEdBQUUsU0FBcUI7b0JBQzNCLGdCQUFhLEdBQUUsS0FBSzt5QkFDcEI7OztnQkFFRixzQkFBTzt3QkFDTCxJQUFJLEVBQUUsR0FBQyxDQUFDLE9BQU87d0JBQ2YsYUFBYSxFQUFFLElBQUk7cUJBQ3BCLEVBQUM7Ozs7Z0JBSUkscUJBQU0sUUFBUSxDQUFDLElBQUksRUFBRSxFQUFBO29CQUQ3Qix1QkFDRSxPQUFJLEdBQUUsU0FBcUI7b0JBQzNCLGdCQUFhLEdBQUUsS0FBSzt5QkFDcEI7Ozs7S0FFTCxDQUFDIn0=
